<template lang="pug">
  panel(:title='$t("ui.game_rules")')
    b-card.text-start.text-capitalize.mb-3(border-variant='grey' header='Live22 老虎机' header-bg-variant='grey' header-class="pt-2 pb-2" header-text-variant='black')
      b-card-text 所有单次累积奖池超过 MYR 100,000 (THB 1,000,000), 公司将承担全部费用。
    b-card.text-start.text-capitalize.mb-3(border-variant='grey' header='Joker 老虎机' header-bg-variant='grey' header-class="pt-2 pb-2" header-text-variant='black')
      b-card-text 除了以下游戏，所有“ Grand” 累积奖池，公司将承担这笔款项的费用。 其他类型的累积奖池则根据占成数计算。
      b-card-text 游戏中的累积奖池 (bonus 功能)
      b-list-group.col-5
        b-list-group-item 1. Black Beard Legacy (海盗传奇)
        b-list-group-item 2. Dragon Of The Eastern Sea (东海龙王)
        b-list-group-item 3. Journey To The West (西游记)
        b-list-group-item 4. Wild Fairies (仙女百搭)
        b-list-group-item 5. OngBak (拳击)
        b-list-group-item 6. Thug Life (玩命之徒)
        b-list-group-item 7. Fortune Festival (財富佳節)
        b-list-group-item 8. Lucky Streak (幸运条纹)
        b-list-group-item 9. Ocean Spray (海洋浪花)
        b-list-group-item 10. Cyber Race (网络竞赛)
        b-list-group-item 11. Gold Trail(黃金獵者)
        b-list-group-item 12. Golden Dragon (金龍發發)
        b-list-group-item 13. Ancient Rome (古罗马)
        b-list-group-item 14. Streets Of Chicago (芝加哥街头)
    b-card.text-start.text-capitalize.mb-3(border-variant='grey' header='Pragmatic 老虎机' header-bg-variant='grey' header-class="pt-2 pb-2" header-text-variant='black')
      b-card-text 不包括所有单次累积奖池。
    b-card.text-start.text-capitalize.mb-3(border-variant='grey' header='PGsoft 老虎机' header-bg-variant='grey' header-class="pt-2 pb-2" header-text-variant='black')
      b-card-text 不包括所有单次累积奖池。
    b-card.text-start.text-capitalize.mb-3(border-variant='grey' header='SimplePlay 老虎机' header-bg-variant='grey' header-class="pt-2 pb-2" header-text-variant='black')
      b-card-text 不包括所有奖池.
    b-card.text-start.text-capitalize.mb-3(border-variant='grey' header='老虎机游戏赔付规则' header-bg-variant='grey' header-class="pt-2 pb-2" header-text-variant='black')
      b-card-text 平台上的老虎机游戏中，任何单笔投注的赔付金额，公司将以 MYR 1,000,000 作为最终赔付上限。
</template>

<script>

export default {
  components: {
  }
}
</script>